import React from 'react';
import PropTypes from 'prop-types';

/**
 * Cohort chips for Lighthouse MRR —
 * green = valid determination, yellow = needs review, blank = not shown.
 */
export function CohortChipGroup({ cohorts }) {
  const list = (Array.isArray(cohorts) ? cohorts : []).filter(
    (c) => (c.color || 'blank') !== 'blank'
  );
  if (list.length === 0) {
    return <span className="onyx-cohort-empty">—</span>;
  }
  return (
    <span className="onyx-cohort-cell" data-testid="onyx-cohort-chips">
      {list.map((c) => {
        const color = c.color || 'blank';
        const passClass =
          c.pass === true ? ' is-pass' : c.pass === false ? ' is-fail' : '';
        return (
          <span
            key={c.slug || c.label}
            className={`onyx-cohort-chip onyx-cohort-chip--${color}${passClass}`}
            title={c.label}
          >
            {c.label || c.slug}
          </span>
        );
      })}
    </span>
  );
}

CohortChipGroup.propTypes = {
  cohorts: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      label: PropTypes.string,
      color: PropTypes.string,
      pass: PropTypes.bool,
    })
  ),
};
